import React from "react"

const BowLeft = ({
  colors = [
    "#939393",
    "#EED793",
    "#B5AC95",
    "#925C25",
    "#AA8B2F",
    "#FFCE06",
    "#42140B"
  ]
}) => {
  return (
    <g id="BowLeft">
      <path
        opacity="0.25"
        d="M43.0091591,118.4887848 c-0.3665543,0-0.641468-0.0916367-0.8247452-0.3665543l-0.2749176-0.8247452l0.0916367-0.4581985l0.2749176-0.4581909 c0,0,0.0916367-0.0916367,0.1832771-0.1832733l31.6152954-71.8446045c0-0.0916367,0-0.1832771,0-0.2749138l0.1832733-0.4581909 l0.2749176-0.3665581l0.8247452-0.4581909c0.6414642,0,1.1913071,0.641468,1.2829437,1.5578537v0.1832809l-0.2749176,0.5498314 c0.0916367-0.0916367,0.0916367-0.0916367,0.0916367-0.0916367s0,0.0916367-0.0916367,0.3665543 c0.0916367,0.9163857,2.0160446,5.2233963,2.9324265,7.3310814l0.2749176,0.6414719 c3.9404602,9.4387665-3.4822617,20.985218-5.9565048,24.7424049c-0.5498276,0.8247528-1.0996552,1.8327713-1.5578537,2.4742355 c0,0.0916443,0,0.1832809,0.0916443,0.2749252l0.0916367,0.0916367l0.0916367,1.0080185l-1.0080261,0.5498276 l-2.5658798,5.7732315l0.2749176,1.0996628l-0.8247452,0.5498276h-0.0916367 c-0.0916367,0.0916367-0.1832809,0.0916367-0.2749252,0.1832733c-0.2749176,0.8247528-0.5498276,1.924408-0.8247452,2.8407974 c-1.1912994,4.3986511-4.6735611,17.5945969-14.2039719,21.0768585l-0.641468,0.1832733 c-2.290966,0.8247528-6.5979767,2.1993256-7.3310852,2.7491608c-0.1832771,0.2749176-0.1832771,0.3665543-0.1832771,0.3665543 s0-0.0916367,0-0.1832733l-0.2749138,0.5498276l-0.1832771,0.0916367 C44.0171852,118.2138748,43.5589943,118.4887848,43.0091591,118.4887848z M45.4834023,114.3650513 c1.7411308-0.9163818,4.3070107-2.0160446,6.78125-3.0240707c6.8728905-2.9324341,9.3471336-12.5544739,10.9049873-18.3277054 l0.2749176-0.9163895c0.2749214-0.9163818,0.4581947-1.7411346,0.6414719-2.3825989l-0.4581947-0.6414642l0.3665543-1.0080261 l0.0916405-0.0916367v-0.0916367l0.2749176-0.4581909l0.4581909-0.2749176l3.0240707-6.9645309l-0.1832733-0.4581909 l0.0916367-0.1832733h0.0916367v-0.1832809l0.4581985-0.9163895l0.8247452-0.0916367 c0.3665543-0.6414642,0.8247452-1.2829361,1.2829437-2.1076889l0.4581909-0.7331085 c3.2073441-5.0401154,8.705658-13.3792229,6.2314224-20.4353905c-0.9163895-2.5658798-1.8327713-5.1317558-2.2909622-7.0561676 L45.4834023,114.3650513z"
      />
      <polygon
        fill={colors[0]}
        points="43.1924362,117.3891296 43.1007996,117.3891296 75.2659225,44.3532181 75.4491959,44.3532181"
      />
      <g fill={colors[1]}>
        <polygon points="70.1341705,83.3912354 68.1181183,82.1082916 67.9348373,82.3832092 67.6599197,83.2079544 69.675972,84.3992538" />
        <polygon points="70.5923615,82.1999283 68.5763092,81.0086365 68.1181183,81.9250183 70.2258072,83.2079544" />
        <polygon points="67.2933731,86.9651413 66.1937103,86.5069427 65.8271484,87.2400513 66.4686279,87.6066055" />
        <polygon points="67.9348373,88.3397141 68.3013992,87.4233322 67.3850098,87.056778 66.5602646,87.6982422" />
        <polygon points="69.2177811,85.40728 67.1100922,84.3076172 66.6519012,85.3156433 68.7595901,86.4152985" />
        <polygon points="68.5763092,86.9651413 68.6679535,86.5985794 66.5602646,85.40728 66.3769913,85.9571075 66.1937103,86.3236618 68.3930359,87.2400513" />
        <polygon points="67.6599197,88.8895493 67.8432007,88.5229874 65.7355118,87.4233322 65.2773209,88.5229874" />
      </g>
      <g fill={colors[2]}>
        <polygon points="69.3094177,85.2240067 69.5843353,84.5825348 68.1181183,83.7577896 67.4766464,84.3992538" />
        <polygon points="67.1100922,84.2159805 67.3850098,84.3076172 68.0264816,83.6661453 67.4766464,83.3912354" />
      </g>
      <g fill={colors[2]}>
        <polygon points="70.6839981,82.1082916 70.9589157,81.3751831 70.5923615,81.1002731 70.1341705,81.6501007" />
        <polygon points="68.6679535,80.8253555 69.950882,81.6501007 70.5007248,81.0086365 69.0345001,79.9089661" />
      </g>
      <path
        fill={colors[3]}
        d="M75.1742859,45.7277985c0.1832733,1.6494904,1.466217,5.315033,2.7491531,8.9805756 c2.7491608,7.7892723-3.4822617,16.8614883-6.78125,21.993248c-0.8247452,1.1912994-1.3745804,2.1993256-1.8327713,2.9324265 l1.466217,1.5578537c0.1832733-0.6414642,1.0996552-2.0160446,2.0160446-3.4822693 c3.4822693-5.315033,9.3471298-15.5785484,5.8648682-23.9176521c-1.2829437-3.0240707-3.390625-7.6976395-3.2073517-8.430748 c0.1832733-0.7331047,0.2749176-0.7331047,0.2749176-0.7331047s-0.0916367-0.7331085-0.4581909-0.7331085l-0.2749176,0.3665543 C75.0826492,44.3532181,75.0826492,44.7197762,75.1742859,45.7277985z"
      />
      <ellipse
        transform="rotate(-44.562 70.13 80.25)"
        fill={colors[4]}
        cx="70.13"
        cy="80.25"
        rx="0.641"
        ry="1.558"
      />
      <polygon
        fill={colors[5]}
        points="71.3254623,81.2835464 69.1261444,78.9009476 68.6679535,79.8173294 71.5087433,82.2915649"
      />
      <polygon
        fill={colors[6]}
        points="67.6599197,88.9811859 68.4846725,87.056778 70.0425262,83.3912354 70.9589157,81.4668274 69.0345001,80.0006027 67.9348373,82.4748459 66.285347,86.0487518 65.1856842,88.5229874"
      />
      <polygon
        fill={colors[5]}
        points="67.751564,89.4393768 64.54422,89.3477402 64.9107666,88.4313507 68.6679535,88.7979126"
      />
      <path
        fill={colors[3]}
        d="M44.2004585,116.1978226c1.3745804-0.9163818,4.856842-2.4742355,8.5223846-4.0320969 c7.6059952-3.2073441,10.0802345-13.9290543,11.6380959-19.8855667 c0.3665543-1.3745728,0.6414642-2.4742355,0.9163818-3.2989807h2.1993256 c-0.2749176,0.5498276-0.7331085,2.1993256-1.1912994,3.8488159 c-1.649498,6.1397781-5.1317596,17.4113159-13.6541443,20.4353867 c-3.1157112,1.0996552-7.9725533,2.6575165-8.4307442,3.2989807c-0.4581947,0.6414719-0.3665581,0.6414719-0.3665581,0.6414719 s-0.641468,0.4581909-0.824749,0.1832733l0.0916405-0.4581909 C43.1007996,117.114212,43.2840767,116.8392944,44.2004585,116.1978226z"
      />
      <ellipse
        transform="rotate(-87.875 66.168 89.17)"
        fill={colors[4]}
        cx="66.168"
        cy="89.171"
        rx="0.641"
        ry="1.558"
      />
      <polygon
        fill={colors[4]}
        points="67.751564,88.7062683 64.9107666,88.4313507 65.0940475,87.9731598 68.0264816,88.2480698"
      />
      <polygon
        fill={colors[4]}
        points="70.7756348,81.9250183 68.5763092,80.092247 68.6679535,79.8173294 70.8672714,81.7417374"
      />
    </g>
  )
}

export default BowLeft
